import { defineNuxtRouteMiddleware, setPageLayout } from '#imports';

export default defineNuxtRouteMiddleware(async (to) => {
  if (import.meta.client) {
    if (to.query.forceDefaultLayout) {
      // 如果URL中有forceDefaultLayout参数，则强制使用default布局
      setPageLayout('default');
    }
  }
});
